import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowR } from "../../assets/images/IZB/arrow_right.svg";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import bannerImg from "../../assets/images/IZB/IZB Website Skin/CASA.png";

const textColor = { color: "#9E1B1E" };

const FaqItem = ({ q, children }) => (
  <div className="mb-3">
    <p className="mb-1">
      <strong>{q}</strong>
    </p>
    <div>{children}</div>
  </div>
);

const thStyle = {
  padding: "12px 20px",
  textAlign: "left",
  color: "#484848",
  borderBottom: "2px solid #9E1B1E",
};

const tdStyle = {
  padding: "12px 20px",
  color: "#fff",
  borderBottom: "1px solid rgba(255,255,255,0.15)",
};

const DataTable = ({ headers, rows }) => (
  <div className="table-responsive">
    <table className="w-100" style={{ borderCollapse: "collapse" }}>
      <thead>
        <tr>
          {headers.map((h) => (
            <th key={h} style={thStyle}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} style={{ backgroundColor: "#9E1B1E" }}>
            {row.map((cell, j) => (
              <td key={j} style={tdStyle}>
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const SaveTodayWinTomorrow = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area">
        <div className="container-fluid py-2" style={{ backgroundColor: "#FFF5E7" }}>
          <div className="row">
            <div className="col-xl-12">
              <div className="inner-content" style={{ margin: "0 40px 0 40px" }}>
                <div
                  className="breadcrumb-area-bg title position-relative"
                  style={{
                    backgroundImage: `url(${bannerImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    height: "420px",
                  }}
                />
                <div className="breadcrumb-menu breadcrumb-menu-updated container position-relative pt-2">
                  <ul className="d-flex justify-content-end align-items-center">
                    <li>
                      <Link to="/">Home</Link>
                      <ArrowR className="mx-1" />
                      Save Today, Win Tomorrow
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#ffffff", padding: "60px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>The Campaign</h3>

          <FaqItem q="What is Save Today, Win Tomorrow?">
            <p>
              It is a three month Indo Zambia Bank campaign that rewards customers for saving. If
              you hold a qualifying Savings, Current or SME Current account and you maintain a
              minimum average balance with regular monthly inflows, you automatically earn entries
              into monthly cash draws and a Grand Prize draw at the end of the campaign. The more
              you save and maintain, the more entries you earn.
            </p>
          </FaqItem>

          <FaqItem q="When does the campaign run?">
            <p>
              From <strong>1 October 2026 to 31 December 2026</strong>. The Grand Prize draw takes
              place in <strong>January 2027</strong>.
            </p>
          </FaqItem>

          <FaqItem q="Do I need to register or sign up?">
            <p>
              No. There is no form to fill in and nothing to opt into. If you hold a qualifying
              account and you meet the monthly balance and inflow requirements, your entries are
              generated automatically from the Bank's own records.
            </p>
          </FaqItem>
        </div>
      </section>

      <section style={{ backgroundColor: "#FFF5E7", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>Who Can Take Part</h3>

          <FaqItem q="Which accounts qualify?">
            <p>
              Three customer categories take part, each competing only against others in the same
              category:
            </p>
          </FaqItem>

          <DataTable
            headers={["Category", "Qualifying account"]}
            rows={[
              ["Retail Savings", "Savings Account"],
              ["Premier Retail", "Premier Banking Current or Savings Account"],
              ["SME", "SME Current Account"],
            ]}
          />

          <p className="mt-3">
            Salary Account holders take part within the category their account falls under.
          </p>

          <FaqItem q="Can a dormant account qualify?">
            <p>
              Not while it is dormant. A dormant account can be reactivated through the Bank's
              normal reactivation process, which includes identity verification and updating your
              KYC records. Once the account is active and meets the requirements, it qualifies from
              that month onward.
            </p>
            <p>Accounts that are dormant at the time of a draw are removed from that draw.</p>
          </FaqItem>

          <FaqItem q="I want to move my salary from another bank. Do I qualify?">
            <p>
              Yes. Customers who transfer their salary to Indo Zambia Bank during the campaign take
              part on exactly the same terms as everyone else, from the first full month in which
              the balance and inflow requirements are met. Any branch can arrange the transfer for
              you.
            </p>
          </FaqItem>

          <FaqItem q="I hold more than one qualifying account. How does that work?">
            <p>
              Entries are calculated per qualifying account within its own category. Regardless of
              how many entries you hold, the limit on how many prizes one customer can win still
              applies.
            </p>
          </FaqItem>
        </div>
      </section>

      <section style={{ backgroundColor: "#ffffff", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>How to Qualify</h3>

          <FaqItem q="What exactly do I have to do?">
            <p>
              In each month of the campaign, maintain at least the minimum average monthly balance
              for your category, and receive at least the minimum monthly inflow of funds into the
              account.
            </p>
          </FaqItem>

          <DataTable
            headers={["Category", "Min. average monthly balance", "Min. monthly inflow"]}
            rows={[
              ["Retail Savings", "K5,000", "K2,500"],
              ["Premier Retail", "K50,000", "K10,000"],
              ["SME Current", "K50,000", "K20,000"],
            ]}
          />

          <div className="mt-3">
            <FaqItem q='What is an "average monthly balance" and how is it worked out?'>
              <p>
                It is the average of your closing balance on every day of the month, every day
                added together and divided by the number of days in that month. It is not your
                balance on one particular day.
              </p>
            </FaqItem>

            <FaqItem q="What happens if my balance drops below the minimum in one month?">
              <p>
                You earn no entries for that month, and you are not removed from the campaign. Any
                month in which you meet both requirements still earns its entries, and those
                entries stay in the pool.
              </p>
            </FaqItem>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#FFF5E7", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>How Entries Work</h3>

          <FaqItem q="How do I earn entries?">
            <span></span>
          </FaqItem>

          <DataTable
            headers={["Category", "Entry rate", "At the minimum"]}
            rows={[
              ["Retail Savings", "1 entry for every K5,000 of average balance", "K5,000 = 1 entry"],
              [
                "Premier Retail",
                "1 entry for every K10,000 of average balance",
                "K50,000 = 5 entries",
              ],
              [
                "SME Current",
                "1 entry for every K10,000 of average balance",
                "K50,000 = 5 entries",
              ],
            ]}
          />

          <p className="mt-3">
            Only complete bands count. Entries are calculated automatically from the Bank's core
            banking records — nobody enters them by hand.
          </p>
        </div>
      </section>

      <section style={{ backgroundColor: "#ffffff", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>Prizes</h3>

          <FaqItem q="What can I win each month?">
            <span></span>
          </FaqItem>

          <DataTable
            headers={["Category", "Winners each month", "Prize"]}
            rows={[
              ["Retail Savings", "1", "K5,000"],
              ["Premier Retail", "1", "K10,000"],
              ["SME Current", "1", "K15,000"],
              ["SME Current", "3", "K30,000"],
            ]}
          />

          <FaqItem q="What is the Grand Prize?">
            <p>
              <strong>K50,000 in cash to each of three customers</strong> — one Retail Savings, one
              Premier Retail and one SME — drawn in January 2027 from all entries accumulated across
              the campaign.
            </p>
          </FaqItem>

          <FaqItem q="How do I contact Indo Zambia Bank?">
            <span></span>
          </FaqItem>

          <DataTable
            headers={["Toll free", "Telephone", "WhatsApp", "Email"]}
            rows={[["8002", "+260 211 389900", "+260 77 179 8616", "customerservice@izb.co.zm"]]}
          />
        </div>
      </section>

      <AllAcountsSection />
    </>
  );
};

export default SaveTodayWinTomorrow;
